import { toast } from "@babackapp/ui/components/sonner";
import { CheckCircledIcon, CrossCircledIcon } from "@radix-ui/react-icons";

const SuccessIcon = <CheckCircledIcon className="size-4 text-green-400" />;
const ErrorIcon = <CrossCircledIcon className="size-4 text-red-400" />;

type ToastProps = {
  title: string;
  message: string;
  type: "success" | "error";
  toastId: string | number;
};

const typeMap = {
  success: SuccessIcon,
  error: ErrorIcon,
} as const;

export default function FormToast({
  title,
  message,
  type,
  toastId,
}: ToastProps) {
  return (
    <div className="bg-gray-900 rounded-xl p-4 text-white/90 relative shadow-lg border border-gray-800">
      <div className="w-80 flex gap-4">
        {typeMap[type]}
        <div className="flex-col gap-1 flex">
          <span className="font-medium text-sm text-white">{title}</span>
          {message && <p className="text-xs text-white/70">{message}</p>}
        </div>
      </div>
      <button
        type="button"
        onClick={() => toast.dismiss(toastId)}
        className="absolute top-2 right-2 text-white/60 hover:text-white/90 transition-colors"
      >
        <CrossCircledIcon className="size-4" />
      </button>
    </div>
  );
}
